import * as React from 'react';
import { connect } from 'react-redux';
import './PersonalInformation.css';
import { Button } from 'react-bootstrap';
import { validateEmail, validateName, validateSurname, validateCellphoneNumber } from '../../../constants/validation';
import { createWebLead, handleNextStep, setQuoteData } from '../../../actions/salesActions';
import KPInputTextArea from '../../BaseTemplate/SSPCustomComponentLibrary/KPInputTextArea/KPInputTextArea';

class PersonalInformation extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            email: this.props.sales.email,
            firstname: this.props.sales.name,
            surname: this.props.sales.surname,
            phone: this.props.sales.cellphoneNumber,
            submitted: false,
            mailRegex: true,
            nameRegex: true,
            surnameRegex: true,
            phoneRegex: true,
            nextDisabled: true,
            hide: true,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeNumbers = this.handleChangeNumbers.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.checkSubmit = this.checkSubmit.bind(this);
    }

    async componentDidMount() {
        await this.checkSubmit();
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
        await this.checkSubmit();
    }

    async handleChangeNumbers(e: any) {
        let name = e.target.name;
        let value = await e.target.value.replace(/[^0-9]/gi, "");
        await this.setState({ [name]: value })
        await this.checkSubmit();
    }

    async handleBlur(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        if (name === "firstname") {
            await this.setState({ nameRegex: validateName.test(value) });
        } else if (name === "surname") {
            await this.setState({ surnameRegex: validateSurname.test(value) });
        } else if (name === "phone") {
            await this.setState({ phoneRegex: validateCellphoneNumber.test(value) });
        } else if (name === "email") {
            await this.setState({ mailRegex: (value !== "" ? validateEmail.test(value) : true) });
        }
    }

    async checkSubmit() {
        const { email } = this.state;
        const { firstname } = this.state;
        const { surname } = this.state;
        const { phone } = this.state;

        if (validateName.test(firstname) && validateSurname.test(surname) && validateCellphoneNumber.test(phone) && (email !== "" ? validateEmail.test(email) : true)) {
            await this.setState({ nextDisabled: false });
        } else {
            await this.setState({ nextDisabled: true });
        }

    }

    handleRedirect(nextPage: string) {
        this.props.redirectTo(nextPage);
    }

    async handleClick() {
        await this.checkSubmit();
        if (!this.state.nextDisabled) {
            let payload = {
                name: this.state.firstname,
                surname: this.state.surname,
                cellphoneNumber: this.state.phone,
                email: this.state.email,
            }

            await this.props.dispatchAction(setQuoteData(payload));
            await this.props.dispatchAction(createWebLead());
            await this.props.dispatchAction(handleNextStep());
        }
    }

    public render() {
        const { email, firstname, surname, phone, submitted, mailRegex, nameRegex, phoneRegex, surnameRegex } = this.state;
        const quoteType = this.props.sales.quoteType;
        return (
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-md-12">
                        <div className="mt-21px mobile-mt-17px mb-21px">
                            <p className="mt-4 mb-1 text-center Lets-get-to-know-ea">Let’s get to know each other... Please fill in your details below.</p>
                            <p className="text-center Lets-get-to-know-ea mb-0px">(This conversation is 100% private. Promise.)</p>
                        </div>
                        <div className="form-row mb-lg-1 mb-20px mobile-mb-0px">
                            <div className="col-12 col-lg-6 mb-2 mb-lg-0">
                                <KPInputTextArea
                                    id="PersonalInputName"
                                    name="firstname"
                                    type="text"
                                    className="mb-15px"
                                    label={"Name"}
                                    alwaysShowLabel={false}
                                    value={this.state.firstname}
                                    notice={(!nameRegex || submitted && !firstname)}
                                    noticeType={"error"}
                                    noticeMessage={"First name must be 3 characters or more"}
                                    successTick={false}
                                    required={true}
                                    readOnly={false}
                                    autoFocus={false}
                                    minLength={3}
                                    maxLength={false}
                                    disabled={false}
                                    form="mainform"
                                    handleChange={(e) => this.handleChange(e)}
                                    onBlur={(e) => this.handleBlur(e)}
                                />
                            </div>
                            <div className="col-12 col-lg-6">
                                <KPInputTextArea
                                    id="PersonalInputSurname"
                                    name="surname"
                                    type="text"
                                    className="mb-15px"
                                    label={"Surname"}
                                    alwaysShowLabel={false}
                                    value={this.state.surname}
                                    notice={(!surnameRegex || submitted && !surname)}
                                    noticeType={"error"}
                                    noticeMessage={"Surname must be 3 characters or more"}
                                    successTick={false}
                                    required={true}
                                    readOnly={false}
                                    autoFocus={false}
                                    minLength={3}
                                    maxLength={false}
                                    disabled={false}
                                    form="mainform"
                                    handleChange={(e) => this.handleChange(e)}
                                    onBlur={(e) => this.handleBlur(e)}
                                />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="col-12 col-lg-6 mb-2 mb-lg-0">
                                <KPInputTextArea
                                    id="PersonalInputPhone"
                                    name="phone"
                                    type="text"
                                    dataType="numbers"
                                    className="mb-15px"
                                    label={"Phone no."}
                                    alwaysShowLabel={false}
                                    value={this.state.phone}
                                    notice={(!phoneRegex || submitted && !phone)}
                                    noticeType={"error"}
                                    noticeMessage={"Whoops, this phone no. is invalid"}
                                    successTick={false}
                                    required={true}
                                    readOnly={false}
                                    autoFocus={false}
                                    minLength={10}
                                    maxLength={10}
                                    disabled={false}
                                    form="mainform"
                                    handleChange={(e) => this.handleChangeNumbers(e)}
                                    onBlur={(e) => this.handleBlur(e)}
                                />
                            </div>
                            <div className="col-12 col-lg-6">
                                <KPInputTextArea
                                    id="PersonalInputEmail"
                                    name="email"
                                    type="email"
                                    className="mb-15px"
                                    label={"Email"}
                                    alwaysShowLabel={false}
                                    value={this.state.email}
                                    notice={(!mailRegex || submitted && !email)}
                                    noticeType={"error"}
                                    noticeMessage={"Whoops, this email address is invalid"}
                                    successTick={false}
                                    required={true}
                                    readOnly={false}
                                    autoFocus={false}
                                    minLength={3}
                                    maxLength={false}
                                    disabled={false}
                                    form="mainform"
                                    handleChange={(e) => this.handleChange(e)}
                                    onBlur={(e) => this.handleBlur(e)}
                                />
                            </div>
                        </div>
                        <div className="justify-content-center mt-20px">
                            <div className="sales-button-holder">
                                <Button className="btn btn-solid-red button-sales-height" id="submitButton" disabled={this.state.nextDisabled} onClick={this.handleClick}>Next</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInformation);